import { render, staticRenderFns } from "./secondHome.vue?vue&type=template&id=e606dbba&scoped=true&"
import script from "./secondHome.vue?vue&type=script&lang=js&"
export * from "./secondHome.vue?vue&type=script&lang=js&"
import style0 from "./secondHome.vue?vue&type=style&index=0&id=e606dbba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e606dbba",
  null
  
)

export default component.exports